import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form5-container" }
const _hoisted_2 = { class: "coord-group" }
const _hoisted_3 = { class: "coord-input-item" }
const _hoisted_4 = { class: "coord-input-item" }
const _hoisted_5 = { class: "upload-gallery-container" }
const _hoisted_6 = { class: "image-mask" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomeMap = _resolveComponent("CustomeMap")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_LocationInformation = _resolveComponent("LocationInformation")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_VueDraggable = _resolveComponent("VueDraggable")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Map = _resolveComponent("Map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: _ctx.form,
      "label-width": "auto",
      "label-position": "top",
      rules: _ctx.rules,
      ref: "ruleForm",
      "status-icon": "",
      class: "custom-form"
    }, {
      default: _withCtx(() => [
        (_ctx.dataForm2 && _ctx.dataForm2.mapSelect === '自定义地图')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "自定义地图（双击添加或消除）"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CustomeMap, {
                  class: "map-view",
                  ref: "CavMap"
                }, null, 512)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, { label: "地理坐标（经纬度）" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "coord-label" }, "纬度 Lat", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.lat,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.lat) = $event)),
                  placeholder: "0.000000",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "coord-label" }, "经度 Lng", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.lng,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.lng) = $event)),
                  placeholder: "0.000000",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_el_button, {
                type: "primary",
                class: "map-picker-btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShow = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_LocationInformation)
                    ]),
                    _: 1
                  }),
                  _cache[9] || (_cache[9] = _createTextVNode(" 打开地图拾取 ", -1))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "地点名称",
          prop: "address"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.address,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.address) = $event)),
              placeholder: "请输入详细地点或标志性建筑名称"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "section-divider" }, [
          _createElementVNode("span", { class: "section-title" }, "关卡位置提示"),
          _createElementVNode("span", { class: "section-subtitle" }, "配置引导玩家寻找此地点的线索内容")
        ], -1)),
        _createVNode(_component_el_form_item, { label: "地点提示标题" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.addressTipName,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.addressTipName) = $event)),
              placeholder: "例如：古桥旁的石碑"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "地点提示内容" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.addressTipContent,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.addressTipContent) = $event)),
              type: "textarea",
              rows: 4,
              placeholder: "详细描述如何找到目标地点..."
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "关卡位置提示图（支持拖拽排序，最多5张）" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_VueDraggable, {
                ref: "el",
                modelValue: _ctx.fileList2,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fileList2) = $event)),
                class: "draggable-image-list",
                animation: 150
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList2, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.uid || index,
                      class: "image-item-card"
                    }, [
                      _createVNode(_component_el_image, {
                        src: item.url,
                        fit: "cover",
                        class: "thumb-img"
                      }, null, 8, ["src"]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", {
                          class: "del-btn",
                          onClick: _withModifiers(($event: any) => (_ctx.clearImage2(index)), ["stop"]),
                          title: "删除图片"
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_7)
                      ])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_ctx.fileList2.length < 5)
                ? (_openBlock(), _createBlock(_component_el_upload, {
                    key: 0,
                    "file-list": _ctx.fileList2,
                    action: _ctx.UpdateApi,
                    "on-success": _ctx.handleAvatarSuccess2,
                    "before-upload": _ctx.beforeAvatarUpload2,
                    "show-file-list": false,
                    "list-type": "picture-card",
                    class: "custom-uploader-card"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "uploader-icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Plus)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["file-list", "action", "on-success", "before-upload"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_Map, {
      isShow: _ctx.isShow,
      onOnMapClose: _ctx.handleCloseMap,
      onOnSubmit: _ctx.handleSubmit
    }, null, 8, ["isShow", "onOnMapClose", "onOnSubmit"])
  ]))
}